import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from 'src/enviroments/environment';
import { ApiResponse } from './api-response.interface';

export interface EmployeeLink {
  IdEmpleado: number;
  CodigoEmpleado: string;
  NombreCompleto: string;
  IdRol: number | null;
  RolName: string | null;
}

export interface LinkUserEmployeeRequest {
  IdUser: string;
  Email: string;
  IdCompany: number;
  IdEmpleado?: number;
  IdRol?: number;
}

@Injectable({
  providedIn: 'root'
})
export class UserEmployeeLinkService {
  private apiUrl = `${environment.apiUrl}`;

  constructor(private http: HttpClient) { }

  /**
   * Verificar si existe un empleado con el email dado y vincular al usuario
   * POST /permissions/user/link-employee
   * Body: { IdUser, Email, IdCompany }
   * Returns: { success, data: { IdEmpleado, CodigoEmpleado, NombreCompleto, IdRol, RolName } }
   */
  linkUserToEmployee(request: LinkUserEmployeeRequest): Observable<ApiResponse<EmployeeLink>> {
    return this.http.post<ApiResponse<EmployeeLink>>(`${this.apiUrl}/permissions/user/link-employee`, request);
  }

  /**
   * Verificar si un usuario ya está vinculado a un empleado
   * GET /permissions/user/{userId}/employee-link
   */
  getUserEmployeeLink(userId: string): Observable<ApiResponse<EmployeeLink | null>> {
    return this.http.get<ApiResponse<EmployeeLink | null>>(`${this.apiUrl}/permissions/user/${userId}/employee-link`);
  }
}
